import { Link } from "react-router-dom";
import type { Resource } from "@/types/content";
import { formatViews } from "@/utils/content";

interface ResourceCardProps {
  resource: Resource;
  rank?: number;
}

export default function ResourceCard({ resource, rank }: ResourceCardProps) {
  return (
    <Link
      to={`/detail/${resource.id}`}
      className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden cursor-pointer hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={resource.cover}
          alt={`${resource.title} 高清封面`}
          title={`${resource.title} 高清无码资源封面`}
          className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-primary-950/10 to-transparent"></div>
        <span className="absolute top-2 left-2 chip bg-primary-500 text-background-50">
          {resource.quality}
        </span>
        <span className="absolute top-2 right-2 chip bg-accent-500 text-background-50">
          <i className="ri-star-fill" aria-hidden="true"></i>
          {resource.rating.toFixed(1)}
        </span>
        {typeof rank === "number" && (
          <span className="absolute bottom-2 left-2 w-7 h-7 rounded-md bg-background-50/95 text-primary-700 font-heading font-extrabold text-sm flex items-center justify-center">
            {rank}
          </span>
        )}
        <div className="absolute bottom-2 right-2 flex items-center gap-1 text-[11px] text-background-100">
          <i className="ri-eye-line" aria-hidden="true"></i>
          {formatViews(resource.views)}
        </div>
      </div>

      <div className="p-3 md:p-4">
        <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950 leading-6 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {resource.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 flex items-center gap-1.5 flex-wrap">
          <span>{resource.year}</span>
          <span className="text-background-400">/</span>
          <span>{resource.region}</span>
          <span className="text-background-400">/</span>
          <span>{resource.type}</span>
        </p>
        <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-6 line-clamp-2">{resource.summary}</p>
        <div className="mt-3 flex items-center gap-1.5 flex-wrap">
          {resource.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="chip bg-secondary-100 text-secondary-900">
              {tag}
            </span>
          ))}
          <span className="chip bg-background-100 text-foreground-500 ml-auto">
            {resource.publishDate}
          </span>
        </div>
      </div>
    </Link>
  );
}